import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { CameraOSDProvider } from "@/contexts/CameraOSDContext";
import { useSunTheme } from "@/hooks/useSunTheme";
import { AdminProvider } from "@/hooks/useAdmin";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";
const VideoPage = lazy(() => import("./pages/VideoPage"));
const PhotoPage = lazy(() => import("./pages/PhotoPage"));
const CategoryPhotoPage = lazy(() => import("./pages/CategoryPhotoPage"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminPanel = lazy(() => import("./pages/AdminPanel"));
const AdminStatus = lazy(() => import("./pages/AdminStatus"));
const AdminSeo = lazy(() => import("./pages/AdminSeo"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));

const queryClient = new QueryClient();

const App = () => {
  useSunTheme();
  return (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <CameraOSDProvider>
      <AdminProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/index" element={<Index />} />
            <Route path="/wideo" element={<VideoPage />} />
            <Route path="/foto" element={<PhotoPage />} />
            <Route path="/foto/:slug" element={<CategoryPhotoPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/status" element={<AdminStatus />} />
            <Route path="/admin/seo" element={<AdminSeo />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
      </AdminProvider>
      </CameraOSDProvider>
    </LanguageProvider>
  </QueryClientProvider>
  );
};

export default App;
